import React from 'react';

export const SvgFullscreen = props => (
  <svg viewBox="0 0 24 24" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 9c0 .55-.45 1-1 1s-1-.45-1-1V5c0-.55.45-1 1-1h4c.55 0 1 .45 1 1s-.45 1-1 1H6v3zm-2 6c0-.55.45-1 1-1s1 .45 1 1v3h3c.55 0 1 .45 1 1s-.45 1-1 1H5c-.55 0-1-.45-1-1v-4zm14 3h-3c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1v3zM15 6c-.55 0-1-.45-1-1s.45-1 1-1h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V6h-3z"
      fill="currentColor"
    />
  </svg>
);
